export default "__VITE_ASSET__fcdeef58__"